import { connect } from 'react-redux';
import HeaderDeadline from 'project/components/header_deadline';

const mapStateToProps = ({ user }) => ({
  user: user.profile_data
});

export default connect(mapStateToProps)(HeaderDeadline);
